export default __webpack_public_path__ + "static/media/fiat-digital.fad5e415.webp";